import { useSubscriptionApi } from '@hooks/api/account/useSubscriptionApi/useSubscriptionApi';
import { usePostApi } from '@hooks/api/usePostApi';
import type {
  SubscriptionCreateCustomer,
  SubscriptionCustomer,
} from 'types/account/subscriptions';
import type { PostApiOptions } from 'types/api';

export function useCreateSubscriptionCustomer(
  options?: Partial<
    PostApiOptions<SubscriptionCustomer, SubscriptionCreateCustomer>
  >
) {
  const api = useSubscriptionApi();

  const {
    post: createSubscriptionCustomer,
    isPosting: isCreatingSubscriptionCustomer,
  } = usePostApi({
    getSuccessMessage: () => 'New customer created',
    request: (params) => api.createSubscriptionCustomer(params),
    ...options,
  });

  return {
    isCreatingSubscriptionCustomer,
    createSubscriptionCustomer,
  };
}
